var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "announcements-page" }, [
    _vm.screenType == "0"
      ? _c("div", { staticClass: "cross" }, [
          _c("div", { staticClass: "swiper-containerFocus" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.swiperList, function (item, index) {
                return _c("div", { key: index, staticClass: "swiper-slide" }, [
                  _c("div", { staticClass: "slide-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c("div", {
                      staticClass: "detail",
                      domProps: { innerHTML: _vm._s(item.content) },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ])
      : _c("div", { staticClass: "vertical" }, [
          _c("div", { staticClass: "swiper-containerFocus" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.swiperList, function (item, index) {
                return _c("div", { key: index, staticClass: "swiper-slide" }, [
                  _c("div", { staticClass: "slide-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c("div", {
                      staticClass: "detail",
                      domProps: { innerHTML: _vm._s(item.content) },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
    _c(
      "div",
      {
        staticClass: "left",
        class: _vm.screenType == 1 ? "verticalLeft" : "",
        on: { click: _vm.prev },
      },
      [
        _c("dsf-icon", {
          staticClass: "icon-fanyezuobeifen8",
          class: _vm.leftClouldRedClass,
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "right",
        class: _vm.screenType == 1 ? "verticalRight" : "",
        on: { click: _vm.next },
      },
      [
        _c("dsf-icon", {
          staticClass: "icon-fanyezuobeifen5",
          class: _vm.rightClouldRedClass,
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }